import { parseCurrency } from '@helper/parseCurrency'

export const parseConciliationBudgetData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'orcamento-id': item.id,
      'orcamento-ano': item.ano,
      'orcamento-gp': item.gerenteOperacoesDescricao,
      'orcamento-gC': item.gerenteCategoriaDescricao,
      'orcamento-empresa': item.empresaId + '-' + item.empresaDescricao,
      'orcamento-categoria': item.categoriaId + '-' + item.categoriaDescricao,
      'orcamento-loja': item.lojaId + '-' + item.lojaDescricao,
      'orcamento-fator-venda': parseCurrency({
        value: item.fatorVendaBruta,
        country: 'pt-br'
      }),
      'orcamento-real-ano-anterior': parseCurrency({
        value: item.vendasUltimoAno,
        country: 'pt-br'
      }),
      'orcamento-comercial': parseCurrency({
        value: item.previsaoComercial,
        country: 'pt-br'
      }),
      'orcamento-alterado-loja': item.alterado ? item.alterado : false,
      'orcamento-orçamento-loja': parseCurrency({
        value: item.previsaoOperacoes,
        country: 'pt-br'
      }),
      'orcamento-alterado-ajustado': item.alterado ? item.alterado : false,
      'orcamento-ajustado': parseCurrency({
        value: item.previsao,
        country: 'pt-br'
      }),
      'orcamento-margem': parseCurrency({
        value: item.margemFinalValor,
        country: 'pt-br'
      }),
      'orcamento-margem-perc': parseCurrency({
        value: item.margemFinal * 100,
        country: 'pt-br'
      }),
      'orcamento-ano-anterior': parseCurrency({
        value: item.duRealizadoAnoPassado,
        country: 'pt-br'
      }),
      'orcamento-du-comercial': parseCurrency({
        value: item.duPrevisaoComercial,
        country: 'pt-br'
      }),
      'orcamento-du-loja': parseCurrency({
        value: item.duPrevisaoOperacoes,
        country: 'pt-br'
      })
    })
  }

  return res
}
